// extracted by mini-css-extract-plugin
export var blockBtn = "main-module--block-btn--77875";
export var mainBtn = "main-module--main-btn--35a4f";
export var mainTitle = "main-module--main-title--178fe";
export var titleH2 = "main-module--title-h2--ff910";